<template>
    <div v-scroll="onScrollSearch">
        <div>
            <vue-headful :title="$t('title_library')" description="title" />
        </div>
        <v-container fluid>
            <v-row class="ma-0">
                <TopBar />
            </v-row>
        <v-card elevation="0" class="py-2 px-3 border-radius-1">
            <v-row class="mt-1">
                <!-- <AssignedBook /> -->
                <v-col cols="12" class="py-0">
                    <v-row align="center" justify="center" justify-md="end">
                        <v-col cols="12" class="py-0">
                            <v-form v-model="valid" @submit="getBooksByTitle">
                                <v-text-field
                                    data-cy="library-search-textfield"
                                    v-model="search"
                                    :label="$t('store.search')"
                                    :rules="tittleRule"
                                    class="search-field"
                                    outlined
                                    dense
                                >
                                    <template #append>
                                        <v-btn
                                            data-cy="search-library-btn"
                                            icon
                                            fab
                                            small
                                            :loading="loading"
                                            @click="getBooksByTitle"
                                        >
                                            <v-icon size="20">fa-search</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row class="">
                <v-col cols="12" class="pa-2">
                    <v-slide-group
                    v-model="categoriesGroup"
                    class="categories-group"
                    show-arrows
                    mobile-breakpoint="960"
                    >
                    <v-slide-item
                        v-for="category in mapCategories"
                        :key="category.id"
                        v-slot="{ active, toggle }"
                    >
                        <v-btn
                            text
                            elevation="0"
                            :color="active ? 'active' : 'primaryLight'"
                            class="btn-icon-text mx-1"
                            :value="category.id"
                            @click="toggle(); setSelectedCategory(category.id, active);">
                            <v-img
                                max-height="38"
                                max-width="38"
                                class="mr-1"
                                :src="category.image"
                            ></v-img>
                            <span v-html="category.name"></span>
                        </v-btn>
                    </v-slide-item>
                    </v-slide-group>
                </v-col>
                <!-- btn seleccionado -->
            </v-row>
        </v-card>

            <v-container v-if="fixedLibrary && fixedLibrarySections.length > 0" v-show="!showSearch">
                <book-carousel-pop-up
                    v-for="(section,id) in fixedLibrarySections"
                    :key="id"
                    :titleCarousel="section.name"
                    :booksList="section.books"

                />
            </v-container>
            <BookSearchContent
                :books="searchBooks.data"
                v-show="showSearch"
                :error-message="searchError"
                :loading="loading"
                :query="search"
                :activeCategory="selectedCategoryName"
                @clean-search="cleanSearch"

            />
            <div class="my-8">
                <!-- Novedades -->
                <book-carousel-pop-up
                    :titleCarousel="$t('library.title_carousel_4')"
                    :subTitleCarousel="$t('library.subtitle_carousel_4')"
                    :booksList="topNewBooksList"
                    v-show="!showSearch"
                    v-if="!fixedLibrary"
                />
            </div>
            <div class="my-8">
                <!-- Los 10 más populares -->
                <book-carousel-pop-up
                    :titleCarousel="$t('library.title_carousel_2')"
                    :subTitleCarousel="$t('library.subtitle_carousel_2')"
                    :booksList="topMostRequestedBooksList"
                    :mostPopular="true"
                    v-show="!showSearch"
                    v-if="!fixedLibrary"
                    class="popular"
                />
            </div>
          

            <div class="my-8">
                <!-- Recomendados para ti -->
                <book-carousel-pop-up
                    :titleCarousel="$t('library.title_carousel_6')"
                    :subTitleCarousel="$t('library.subtitle_carousel_6')"
                    :booksList="suggestedBooks"
                    v-show="!showSearch"
                />
            </div>
            <!-- Continua tu lectura -->
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_7')"
                :subTitleCarousel="$t('library.subtitle_carousel_7')"
                :booksList="readingBookListUser"
                v-show="!showSearch"
            />
        </v-container>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import { loadScript } from "vue-plugin-load-script";
import _ from 'lodash';
import AssignedBook from '@/components/home/AssignedBook.vue'
import TopBar from '@/components/home/TopBar.vue'
import BookCarouselPopUpVue from '@/components/library/BookCarouselPopUp.vue'
import BookSearchContent from '@/components/library/BookSearchContent.vue'
import bookService from '../../services/book'
let Airtable = null;

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

import AnalyticEventsMixin from "@/mixins/analyticEvents"
import timeTrackerMixin from '@/mixins/timeTrackerMixin'

import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    mixins: [AnalyticEventsMixin, timeTrackerMixin],
    data() {
        return {
            modalActive: false,
            active: true,
            categoryBtnClass: 'btn-select',
            categoryName: 'Categorías',
            selectedCategory: '',
            selectedCategoryName: '',
            favoriteBookListUser: {
                code: 0,
                data: [],
            },
            boughtBookListUser: {
                code: 0,
                data: [],
            },
            topRatingBookListUser: {
                code: 0,
                data: [],
            },
            mostRequestedBooks: {
                code: 0,
                data: [],
            },
            newBooks: {
                code: 0,
                data: [],
            },
            searchBooks: {
                code: 0,
                data: [],
            },
            suggestedBooks: {
                code: 0,
                data: [],
            },
            readingBookListUser: {
                code: 0,
                data: [],
            },
            search: '',
            page: 0,
            sizeForSearch: 30,
            valid: true,
            showSearch: false,
            loading: false,
            searchError: '',
            last: false,
            empty: false,
            payPage: 0,
            paySize: 100,
            fixedLibrary: false,
            fixedLibraryBooks: [],
            fixedLibrarySections: [],
            categoriesGroup: [],
            logoHome: require('@/assets/img/icons/navbar/home.png'),
            settings: {
                infinite: false,
                arrows: false,
                variableWidth: true,
                speed: 500,
                rows: 1,
                slidesToShow: 4,
                slidesToScroll: 4,
                initialSlide: 0,
            },
            categoryLinks: {
                PasatiempoDeportes: '/img/categories/pasatiempo-y-deportes.png',
                MisterioTerror: '/img/categories/misterio-y-terror.png',
                AventurasViajes: '/img/categories/aventuras-y-viajes.png',
                FantasiaMundos: '/img/categories/fantasia-y-otros-mundos.png',
                ArteCultura: '/img/categories/arte.png',
                NaturalezaAnimales: '/img/categories/naturaleza-y-animales.png',
                CienciasUniverso: '/img/categories/ciencia-y-universo.png',
                TecnologiaInventos: '/img/categories/tecnologia-e-inventos.png',
                PensamientosEmociones: '/img/categories/pasatiempo-y-emociones.png',
                HistoriaVidaReal: '/img/categories/historia-y-vida-real.png',
                HumorCuriosidades: '/img/categories/humor-y-curiosidades.png',
                CocinaVidaCotidiana: '/img/categories/cocina-y-vida-cotidiana.png',
            },
        }
    },
    created() {
        this.getFavoriteBooksList()
        this.getBoughtBooksList()
        this.getMostRequestedBooksPage()
        this.getNewBooksPage()
        this.getSuggedtedBooksList()
        this.getReadingBooksByUser()
    },
    mounted() {
        if (_.endsWith(this.user.school.rbd, "restricted")) {
            this.fixedLibrary = true
            this.loadFixedLibrary(this.user.school.id)
        }
        this.createAnalyticEvent(AnalyticEventTypes.GoToLibrary)
    },
    props: ['mostPopular'],
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            course_id: (state) => state.userData.user.course.id,
            user: (state) => state.userData.user,
            categories: (state) => state.categories,
            grade: (state) => state.userData.user.course.ordinalGrade,
        }),
        mapCategories() {
            const vm = this
            return this.categories.map((category) => {
                return {
                    id: category.id,
                    name: this.$t(`categories_tl.${category.value}`),
                    image: vm.setCategoryLink(category.value),
                }
            })
        },
        favoriteBookList() {
            return this.favoriteBookListUser
        },
        boughtBookList() {
            return this.boughtBookListUser
        },
        topMostRequestedBooksList() {
            return this.mostRequestedBooks
        },
        topNewBooksList() {
            return this.newBooks
        },
        suggestedBooksList() {
            return this.suggestedBooks
        },
        tittleRule() {
            return [() => !!this.search || this.$t('library.book_tittle_required')]
        },
    },
    components: {
        AssignedBook,
        TopBar,
        'book-carousel-pop-up': BookCarouselPopUpVue,
        BookSearchContent,
        VueSlickCarousel,
    },
    methods: {
        setCategoryLink(value){
            return this.categoryLinks[value] ?? value
        },
        setSelectedCategory(category, active) {
            this.page = 0
            // Buscar el nombre de la categoría seleccionada
            const selectedCategory = this.mapCategories.find(cat => cat.id === category);
            if (selectedCategory) {
                this.selectedCategoryName = selectedCategory.name
            } else {
                this.selectedCategoryName = ''
            }

            if(!active){
                this.selectedCategory = category
                this.getBooksByTitle()
                return;
            }

            this.selectedCategory = null
            this.getBooksByTitle()

            this.cleanSearch()

        },
        getFavoriteBooksList() {
            bookService
                .getBookListFavoriteByUser(this.user_id)
                .then((response) => {
                    if (response.content.length > 0) {
                        this.favoriteBookListUser = {
                            code: 1,
                            data: response.content,
                        }
                    } else {
                        this.favoriteBookListUser = {
                            code: 2,
                            data: response.content,
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.favoriteBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getSuggedtedBooksList() {
            bookService
                .getBookListSuggestedForUser(this.user_id)
                .then((response) => {
                    if (response.content && response.content.length > 0) {
                        this.suggestedBooks = {
                            code: 1,
                            data: response.content,
                        }
                    } else {
                        this.suggestedBooks = {
                            code: 2,
                            data: response.content,
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.suggestedBooks = {
                        code: 3,
                        error,
                    }
                })
        },
        getBoughtBooksList() {
            bookService
                .getAllPayBooksByUser(this.user_id, this.payPage, this.paySize)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.boughtBookListUser = {
                            code: 1,
                            data: response.content.content,
                        }
                    } else {
                        this.boughtBookListUser = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.boughtBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getReadingBooksByUser() {
            bookService
                .getReadingBooksByUser(this.user_id)
                .then((response) => {
                    if (response.content && response.content.length > 0) {
                        this.readingBookListUser = {
                            code: 1,
                            data: response.content.map(catalog => catalog.book),
                        }
                    } else {
                        this.readingBookListUser = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.readingBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getMostRequestedBooksPage() {
            bookService
                .getMostRequestedBooksPage(this.grade)
                .then((response) => {
                    if (response.content && response.content.length > 0) {
                        this.mostRequestedBooks = {
                            code: 1,
                            data: response.content,
                        }
                    } else {
                        this.mostRequestedBooks = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.mostRequestedBooks = {
                        code: 3,
                        error,
                    }
                })
        },
        getNewBooksPage() {
            bookService
                .getNewBooksPageByGrade(this.grade)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.newBooks = {
                            code: 1,
                            data: response.content.content,
                        }
                    } else {
                        this.newBooks = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.newBooks = {
                        code: 3,
                        error,
                    }
                })
        },
        async getBooksByTitle($event) {
            if ($event) $event.preventDefault()

            if (this.search || this.selectedCategory) {
                // Reset search data when starting a new search (page 0) or when searching by title
                if (this.page === 0 || this.search !== '') {
                    this.searchBooks = { data: [] }
                    // Reset page when searching by title
                    if (this.search !== '') {
                        this.page = 0
                    }
                }
                this.showSearch = true
                this.loading = true
                this.$ga.event('input', 'searchBook')
                const response = await bookService
                    .getBookListByTittle({ 
                        title: this.search, 
                        number: this.search !== '' ? 0 :  this.page, 
                        size: this.sizeForSearch, 
                        categories: this.selectedCategory ? [this.selectedCategory, 0].join(',') : '',
                        grade: this.grade 
                    })
                    .catch((error) => {
                        Sentry.captureException(error)
                        this.searchError = error.message
                    })
                if (response) {
                    const { content: contentData } = response
                    const { content, last, empty } = contentData
                    this.empty = empty
                    this.last = last
                    if (!empty) {
                        this.$ga.event('books', 'searchBookFound')
                        if (this.fixedLibrary) {
                            const filteredSearchBooks = [...this.searchBooks.data, ...content].filter((book) => {
                                return _.includes(_.map(this.fixedLibraryBooks, 'id'), book.id)
                            })
                            if (filteredSearchBooks.length > 0){
                                this.searchBooks = { data: filteredSearchBooks }
                            } else{
                                this.searchBooks = { data: [] }
                                this.searchError = this.$t('library.not_books_data')
                            }
                        } else {
                            this.searchBooks = { data: [...this.searchBooks.data, ...content] }
                            this.searchError = false
                        }
                    } else {
                        this.$ga.event('books', 'searchNotBookFound')
                        this.searchBooks = { data: [] }
                        this.searchError = this.$t('library.not_books_data')
                    }
                } else {
                    this.$ga.event('books', 'searchNotBookFound')
                    this.searchBooks = { data: [] }
                    this.searchError = this.$t('library.not_books_data')
                }
                this.loading = false
            }
        },
        cleanSearch() {
            this.showSearch = false
            this.search = ''
            this.categoriesGroup = []
            this.selectedCategory = 0
            this.selectedCategoryName = ''
            this.page = 0
            this.searchBooks = { data: [] }
        },
        onScrollSearch() {
                if (this.showSearch && !this.last && !this.empty && this.scrollEnds() && this.searchBooks.data.length === this.sizeForSearch) {
                this.page += 1
                console.log('page', this.page)
                this.getBooksByTitle()
            }
        },
        scrollEnds() {
            const currentHeight = parseFloat(window.innerHeight + window.scrollY).toFixed(0);
            return Number(currentHeight) === document.body.offsetHeight
        },
        loadAirtable() {
            loadScript("https://s3.us-east-2.amazonaws.com/beereaders.com/lib/airtable.browser.js")
            .then(() => {
                // Script is loaded, do something
                Airtable = window.require('airtable')
                this.loadFixedLibrary()
            })
            .catch(() => {
                // Failed to fetch script
                console.log('Unable to load Airtable')
            });
        },
        loadFixedLibrary() {
            const vm = this;
            if (Airtable) {
                const base = new Airtable({apiKey: 'keyed4Q3x3VmpjUMK'}).base('app4LuUIH9qFukCVo');
                base('Books').select({
                    // Selecting the first 3 records in Grid view:
                    // maxRecords: 50,
                    view: "Grid view"
                }).eachPage(function page(records, fetchNextPage) {
                    // This function (`page`) will get called for each page of records.
                    records.forEach((record) => {
                        try {
                            if (_.includes(record.get('BeeReaders ID (from Schools)'), vm.user.school.id.toString())) {
                                vm.fixedLibraryBooks.push({
                                    id: record.get('id'),
                                    title: record.get('title'),
                                    resourceDir: record.get('resourceDir'),
                                    bookAbstract: record.get('bookAbstract'),
                                    fromAge: record.get('fromAge'),
                                    toAge: record.get('toAge')
                                })
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    });

                    // To fetch the next page of records, call `fetchNextPage`.
                    // If there are more records, `page` will get called again.
                    // If there are no more records, `done` will get called.
                    try {
                        fetchNextPage();
                    } catch(er) {
                        console.log(er)
                    }

                }, function done(err) {
                    if (err) console.error(err)
                    _.forEach(_.groupBy(vm.fixedLibraryBooks, 'fromAge'), (group, ageGroup) => {
                        vm.fixedLibrarySections.push(
                            {
                                name: `Edad recomendada ${ageGroup}+`,
                                books: {
                                    code: 1,
                                    data: _.take(group, 10)
                                }
                            }
                        )
                    })
                });
            } else {
                this.loadAirtable()
            }
        }
    },
    watch: {
        selectedCategory() {
            console.log(this.selectedCategory)
        },
        selectedCategoryName(newValue) {
            console.log('selectedCategoryName cambió a:', newValue);
        },
        search() {
            // Reset page when search term changes
            this.page = 0
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
